import {
  greenWallet,
  orangeCoin,
  orangeGrowth,
  purpleGrowth,
} from "@/common/components/icons/svg-icons";
import { IDRFBalance, ISalesPerformance } from "@/common/types/others";
import { monthMapper } from "@/common/utils/general";
import { BiBullseye } from "react-icons/bi";
import { BsRocketTakeoff } from "react-icons/bs";

export const accountantFinancialsCards = (data: IDRFBalance) => [
  {
    id: 1,
    title: "DRF Balance",
    value: data?.drf_balance,
    icon: greenWallet,
    color: "#43A047",
  },
  {
    id: 2,
    title: "Recent Fund Allocation",
    value: data?.recent_fund_allocations,
    icon: orangeCoin,
    color: "#FF9800",
  },
  {
    id: 3,
    title: "Total Allocations",
    value: data?.total_allocations,
    icon: purpleGrowth,
    color: "#673AB7",
  },
  {
    id: 4,
    title: "Total Request Submitted",
    value: data?.total_requests_submitted,
    icon: orangeGrowth,
    color: "#FF5722",
  },
];

export const accountantFinancialsTableHeaders = [
  "Month",
  "Total Sale",
  "Sale Revenue",
  "Restocking Cost",
  "Net Balance",
];

export const accountantFinancialsTableKeys = [
  "month",
  "total_sales",
  "sales_revenue",
  "restocking_cost",
  "net_balance",
];

export const getAccountantFinancialsTableData = (data: ISalesPerformance[]) => {
  if (!data || data.length === 0) return [];

  const result = data?.map((dataItem: ISalesPerformance, index: number) => ({
    id: index,
    month: {
      value: monthMapper[Number(dataItem?.month)],
      type: "string",
    },
    net_balance: { value: dataItem?.net_balance, type: "string" },
    restocking_cost: { value: dataItem?.restocking_cost, type: "string" },
    sales_revenue: { value: dataItem?.sales_revenue, type: "string" },
    total_sales: { value: dataItem?.total_sales, type: "string" },
  }));
  return result;
};

export const accountantAuditTableHeaders = [
  "Date",
  "Time",
  "User",
  "Action",
  "Details",
];

export const accountantAuditTableKeys = [
  "date",
  "time",
  "user",
  "action",
  "details",
];

export const getAccountantAuditTableData = () => {
  return new Array(10).fill(0).map((_, index: number) => ({
    id: `${index}`,
    date: { value: "10-10-2025", type: "string" },
    time: { value: "10:24", type: "string" },
    user: { value: "Ahmed Bello", type: "string" },
    action: { value: "sales", type: "string" },
    details: {
      value: "Sold 50 Units of Amoxicillin at N100 each",
      type: "string",
    },
  }));
};

export const salesTableHeaders = [
  "Product Name",
  "Invoice ID",
  "Date of Sale",
  "Qty Sold",
  "Unit Price(N)",
  "Total Revenue",
  "Sold By",
];

export const salesTableKeys = [
  "product_name",
  "invoice_id",
  "date_of_sale",
  "qty_sold",
  "unit_price",
  "total_revenue",
  "sold_by",
];

export const getSalesTableData = () => {
  return new Array(10).fill(0).map((_, index: number) => ({
    id: `${index}`,
    product_name: { value: "Emzor Paracetamol", type: "string" },
    invoice_id: { value: "INV-25-001", type: "string" },
    date_of_sale: { value: "07-09-2024", type: "string" },
    qty_sold: { value: "5", type: "string" },
    unit_price: { value: "5000", type: "string" },
    total_revenue: { value: "25,000", type: "string" },
    sold_by: { value: "Emanuel Adebayo", type: "string" },
  }));
};
export const restockingTableHeaders = [
  "Product Name",
  "Restock Date",
  "Qty Added",
  "Unit Price(N)",
  "Supplier",
  "Logged By",
];

export const restockingTableKeys = [
  "product_name",
  "restock_date",
  "qty_added",
  "unit_price",
  "supplier",
  "logged_by",
];

export const getRestockingTableData = () => {
  return new Array(10).fill(0).map((_, index: number) => ({
    id: `${index}`,
    product_name: { value: "Emzor Paracetamol", type: "string" },
    restock_date: { value: "07-09-2024", type: "string" },
    qty_added: { value: "5", type: "string" },
    unit_price: { value: "5000", type: "string" },
    supplier: { value: "GWAP Enterprise", type: "string" },
    logged_by: { value: "Emanuel Adebayo", type: "string" },
  }));
};

export const accountStat = [
  {
    icon: BsRocketTakeoff,
    title: "Most Sold Item (by volume)",
    item: "Paracetamol(500mg)",
    value: 120,
  },
  {
    icon: BiBullseye,
    title: "Highest Revenue Contributor",
    item: "Metformin",
    value: 57000,
  },
];

export const lineChartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      display: false,
    },
    title: {
      display: false,
    },
  },
  scales: {
    x: {},
    y: {
      beginAtZero: true,
      max: 1500,
      ticks: {
        stepSize: 300,
        autoSkip: false,
        callback: (value: any) => `${value}`,
      },
    },
  },
};

export const lineChartData = {
  labels: ["Week1", "Week2", "Week3", "Week4"],
  datasets: [
    {
      label: "Weekly sales",
      data: [500, 510, 800, 570],

      borderColor: "rgba(75,192,192,1)",
      borderWidth: 2,
      tension: 0.4,

      pointBackgroundColor: "white",
      pointBorderColor: "rgba(75,192,192,1)",
      pointRadius: 4,
      pointHoverRadius: 6,

      fill: true,
      backgroundColor: "rgba(75,192,192,0.2)",
    },
  ],
};
